var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtlStateBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "etl_state_blue_svg__a",
    d: "M0 0h19.558v6.424H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "etl_state_blue_svg__c",
    d: "M0 0h14.077v5.711H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.315 16.24a5.5 5.5 0 10-11 0 5.5 5.5 0 1011 0",
    fill: "#3088F4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "etl_state_blue_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#etl_state_blue_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.558 4.272v-.871a.345.345 0 00-.053-.173C19.067 1.602 15.692 0 9.779 0 3.883 0 .51 1.594.058 3.215A.377.377 0 000 3.401v.871c1.11 1.119 4.818 2.152 9.779 2.152 4.962 0 8.67-1.033 9.779-2.152",
    fill: "#777",
    mask: "url(#etl_state_blue_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.854 11.325a32.325 32.325 0 001.986-.003 28.497 28.497 0 004.26-.439 7.814 7.814 0 014.457-2.373V5.624c-1.904 1.264-5.929 1.933-9.779 1.933-3.85 0-7.875-.668-9.778-1.933v3.553c1.032 1.041 4.316 2.007 8.717 2.143l.137.004",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.582)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "etl_state_blue_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#etl_state_blue_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 5.555a7.784 7.784 0 011.097-3.891c-.991.131-2.081.22-3.28.252a34.676 34.676 0 01-2.041 0C5.885 1.839 3.598 1.448 1.95.889 1.176.637.512.339 0 0v3.552c1.114 1.123 4.849 2.159 9.779 2.159 1.138 0 2.208-.057 3.2-.156",
    fill: "#777",
    mask: "url(#etl_state_blue_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.056 17.312a34.738 34.738 0 01-3.278.148c-4.829 0-8.16-.865-9.778-1.966v3.1c0 .06.016.119.045.17.463 1.85 4.595 3.23 9.733 3.23 1.921 0 3.701-.192 5.202-.53a7.795 7.795 0 01-1.924-4.152",
    fill: "#777"
  }))));
}
export default SvgEtlStateBlue;